import service from '@/services/group';

const loadData = (pagination, commit) => {
  service.getAllGroupsTable(pagination).then(res => {
    commit('loadAllGroupsTableSuccess', res);
  });
};
export default {
  loadproductGroupsTable: ({ commit, state }) => {
    service
      .getProductGroupsTable(state.table.pagination)
      .then(response => commit('loadProductGroupsTableSuccess', response))
      //eslint-disable-next-line no-console
      .catch(err => console.error(err));
  },
  setTablePagination({ commit }, payload) {
    return commit('setTablePagination', payload);
  },

  setListSortBy({ commit }, payload) {
    return commit('setListSortBy', payload);
  },
  loadSpecifiedGroup({ commit }, payload) {
    service.getSpecifiedGroup(payload).then(res => {
      return commit('loadSpecifiedGroupSuccess', res);
    });
  },
  loadShopProducts({ commit }, payload) {
    service.getAllShopProducts(payload).then(res => {
      return commit('loadShopProductsSuccess', res);
    });
  },
  loadAllGroupsTable({ commit, state }) {
    commit('setAllGroupsTableLoading', true);
    service.getAllGroupsTable(state.allGroupsTable.pagination).then(res => {
      return commit('loadAllGroupsTableSuccess', res);
    });
  },
  setPagination({ commit }, payload) {
    commit('setPagination', payload);
  },
  addNewGroup({ state, commit }, payload) {
    //820 notes: unused variable removed
    service
      .addNewGroup(payload)
      .then(() => {
        loadData(state.allGroupsTable.pagination, commit);
      })
      .catch(() => {});
  },
  removeSpecifiedGroup({ commit, state }, payload) {
    service.removeGroup(payload).then(() => {
      loadData(state.allGroupsTable.pagination, commit);
    });
  },
};
